module.exports = __webpack_public_path__ + "static/media/IMG_9985.5cc01911.JPG";